<dx-popup [width]="400" [height]="500" [showTitle]="true" title="People Lookup" [dragEnabled]="false"
  [closeOnOutsideClick]="true" [showCloseButton]="true" container=".dx-viewport" [(visible)]="adUserSearchVisible">

  <dxo-position at="center" my="center" [of]="positionId"> </dxo-position>
  <form #adUserForm="ngForm" (ngSubmit)="searchUsers(adUserForm)">
    <dx-form>
      <dxi-item>
        <div for="searchHint">Name Contains:</div>
        <div class="row">
          <div class="col-9 pr-0">
            <dx-text-box id="searchHint" [(value)]="searchHint">
            </dx-text-box>
          </div>
          <div class="col-3 pr-0 pl-1 text-left">
            <dx-button (onClick)="searchUsers(adUserForm)" class="ap-green-btn mr-1" text="Search"></dx-button>
          </div>
        </div>
        <span style="color: red;" *ngIf="isNotValid">At least 2 characters must be entered</span>
        <div class="mt-2" for="searchResult">Search Result:</div>
        <dx-list #list id="searchResult" [(dataSource)]="adUsers" [height]="300" selectionMode="single"
          [selectedItemKeys]="[]" [searchEnabled]="true" selectAllMode="page" selectAllText="Select All"
          [showSelectionControls]="true" searchExpr="displayName" searchMode="contains">
          <div *dxTemplate="let data of 'item'">
            <div>{{ data.displayName }}</div>
          </div>
        </dx-list>
        <div class="row">
          <div class="col-12 mt-4 text-right">
            <dx-button (onClick)="apply()" class="ap-green-btn mr-1" text="Apply"></dx-button>
            <dx-button (onClick)="closeDialog()" class="discard-button" text="Cancel"></dx-button>
          </div>
        </div>
      </dxi-item>
    </dx-form>
  </form>
</dx-popup>

<dx-toast *ngIf="isToastVisible" [message]="toastMessage" [(visible)]="isToastVisible" [type]="type" position="top">
</dx-toast>